import React from 'react'
import Select from '../Select'
import options from './lib/options'

export default (props) => (
  <Select label='System of units' options={options} {...props} />
)
